<template>
  <!-- 充值确认信息弹窗 -->
  <custom-dialog
    v-if="dialogVisible"
    width="400px"
    top="23vh"
    :visible="dialogVisible"
    title="充值信息确认"
    :cancelLoading="cancelBtnLoading"
    :show-close="false"
    @close="closeHandle"
    @save="confirmHandle"
  >
    <div slot="content">
      <div class="content">
        <div class="item"> 
          <div class="item-title">充值会员：</div>
          <div class="item-content">
            <div class="item-content-num">{{ rechargeOrderInfo.phone || '' }}</div>
            <div class="item-content-name">（{{ rechargeOrderInfo.memberName || 0 }}）</div>
          </div>
        </div>
        <div class="item"> 
          <div class="item-title">充值金额：</div>
          <div class="item-content">
            ￥{{ rechargeOrderInfo.prePayAmount || 0 }}
          </div>
        </div>
      </div>
    </div>
  </custom-dialog>
</template>
 
<script>
  import req from '@/utils/request'
  export default {
    data() {
      return {
        cancelBtnLoading: false
      }
    },
    methods: {
      confirmHandle() {
        if (this.cancelBtnLoading) return
        this.$emit('confirm')
      },

      async closeHandle() {
        const params = {
          rechargePayRecordId: this.rechargeOrderInfo.id
        }
        this.cancelBtnLoading = true
        const { code } = await req.post('/member/wallet/recharge/cancel', params)
        this.cancelBtnLoading = false
        if (code === 200) {
          this.dialogVisible = false
        }
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      rechargeOrderInfo: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    components: {
      CustomDialog: () => import('@/components/customDialog/CustomDialog')
    },
    filters: {
 
    }
  }
 
</script>

<style scoped lang='less'>
  .content .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
    font-size: 14px;
  }
  .content .item .item-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 72px);
    color: #FE8F1F ;
    font-size: 20px;
    font-weight: 600;
  }

  .content .item .item-content-name {
    margin-left: 10px;
    width: 46%;
    font-size: 14px;
    font-weight: 400;
    color: #667182;
  }
</style>